export enum PostBoxControls {
  postbox = 'postbox',
  city = 'city',
}
